import { isNil } from 'lodash'

import { SchemaItem } from '../interface'

export const isVisibleField = (item: SchemaItem) => {
  return isNil(item['x-display']) || item['x-display'] === 'visible'
}
